import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../AuthProvider.tsx";

type NavItem = {
  to: string;
  label: string;
  exact?: boolean;
};

type PortalSidebarProps = {
  className?: string;
  mobile?: boolean;
  onClose?: () => void;
};

const navItems: NavItem[] = [
  { to: "/", label: "Kampagnen", exact: true },
  { to: "/settings", label: "Einstellungen" },
];

export default function PortalSidebar({ className = "", mobile = false, onClose }: PortalSidebarProps) {
  const { logout } = useAuth();

  return (
    <aside className={`portal-sidebar ${className}`.trim()}>
      <div className="portal-sidebar-top">
        <div className="portal-sidebar-header">
          <div className="portal-brand">WerbeAuto.ch</div>
          {mobile && onClose && (
            <button
              className="portal-drawer-close"
              onClick={onClose}
              aria-label="Navigation schließen"
            >
              ×
            </button>
          )}
        </div>
        <nav className="portal-nav">
          {navItems.map(({ to, label, exact }) => (
            <NavLink
              key={to}
              to={to}
              end={exact}
              className={({ isActive }) =>
                `portal-nav-link${isActive ? " active" : ""}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <button className="portal-logout" onClick={() => logout()}>
        Logout
      </button>
    </aside>
  );
}
